
$(function () {
    var id = $('.expand-list').first().attr('id');
    $(window).bind('hashchange', function (e) {
        if (e.fragment === "") {
            e.fragment = $('.expand-list > li').first().attr('id');
        }
        else {
            var offset = $('.expand-list').first().offset();

            if (offset) {
                $('html,body').scrollTop(offset.top);
            }
        }
        $('.expand-list > li')
            .removeClass('selected')
            .each(function (index, element) {
                if (e.fragment.indexOf($(element).attr('id')) != -1) {
                    $(element).addClass('selected');


                    return false;
                }
            });
    });
    $('.expand-list li > h3')
        .each(function (index, element) {
            var li_id = id + '-li-' + index;
            $(element).parent().attr('id', li_id);
            $(element).wrap('<a href="#' + li_id + '" />');
        });
    $(window).trigger('hashchange');

    $('.document-player').popupWindow({
        centerBrowser: 1,
        width: 424,
        height: 318,
        resizable: 1
    });
});
